//TODO: Remove the unused interfaces after hooking up with backend data

enum ModalForm {
    ADD_CUSTOMER = 'addCustomer',
    EDIT_CUSTOMER = 'editCustomer',
    EMPTY = '',
}

export interface Option {
    id: number | string;
    name: string | number;
    disabled?: boolean;
}

export { ModalForm };
